export default {
  CLOCK: 'clock',
  HOME: 'home',
  LOGO: 'logo',
  LOGOUT: 'logout',
  SETTINGS: 'settings',
  STATS: 'stats',
  DASHBOARD: 'dashboard',
  TASKS: 'tasks',
  PERSON: 'person',
  USER_STATS: 'userStats',
  CHEVRON_RIGHT: 'chevronRight',
  CHEVRON_LEFT: 'chevronLeft',
  FILE_DOWNLOAD: 'fileDownload',
  QUALIFICATIONS: 'qualifications',
  CHAINING: 'chaining',
  FILES: 'files'
};